import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyApiModelStub } from '@webapp/core/data-access/api-models/stubs/CurrencyApiModel.stub'
import { ExternalBankAccountTypes } from '@webapp/platform/banking/entities/enums/ExternalBankAccountTypeEnum'
import { type ExternalBankAccountApiModel } from '../ExternalBankAccountApiModel'

export const ExternalBankAccountApiModelStub =
  Factory.Sync.makeFactory<ExternalBankAccountApiModel>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.finance.accountName()),
    type: ExternalBankAccountTypes.OTHER,
    currency: Factory.each(() => CurrencyApiModelStub.build()),
    gl_code: Factory.each(() => faker.random.alphaNumeric(6)),
    data: {
      description: faker.lorem.sentence(),
    },
  })
